<template>
  <d-modal
    size="lg"
    class="puesc-sent100-popup-modal"
    @close="cancel">
    <d-modal-header>
      <d-modal-title>
        {{ $t('order.puesc.sent100popup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="sent100-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('order.puesc.sent100popup.weight') }}:
            </label>

            <validation-provider
              rules="required|min_value:0.01"
              name="weight"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="number"
                :min="1"
                :step="1"
                v-model="weight" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('order.puesc.sent100popup.carriageDate') }}:
            </label>

            <validation-provider
              rules="required"
              name="carriageDate"
              v-slot="{ errors }">
              <d-datepicker
                v-model="plannedStartCarriageDate"
                :monday-first="true"
                :state="errors.length ? 'invalid' : null"
                format="yyyy-MM-dd"
                :placeholder="$t('ui.chooseDate')"
                class="text-danger"
                :disabled-dates="disabledDates"
                :language="translationsForDatePicker" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <h5 class="mt-4">{{ $t('order.puesc.sent100popup.loadingSection') }}</h5>

          <div class="form-group">
            <label>
              {{ $t('order.puesc.sent100popup.street') }}:
            </label>

            <validation-provider
              rules="required"
              name="loadingStreet"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="text"
                v-model="loading.street" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <d-row>
            <d-col cols="6">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.houseNumber') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="loadingHouseNumber"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="loading.house_number" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>

            <d-col cols="6">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.flatNumber') }}:
                </label>

                <d-input
                  type="text"
                  v-model="loading.flat_number" />
              </div>
            </d-col>
          </d-row>

          <d-row>
            <d-col cols="8">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.city') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="loadingCity"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="loading.city" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>

            <d-col cols="4">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.postCode') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="loadingPostCode"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="loading.post_code" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
          </d-row>

          <h5 class="mt-4">{{ $t('order.puesc.sent100popup.recipientSection') }}</h5>

          <div class="form-group">
            <label>
              {{ $t('order.puesc.sent100popup.name') }}:
            </label>

            <validation-provider
              rules="required"
              name="recipientName"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="text"
                v-model="recipient.name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('order.puesc.sent100popup.taxNumber') }}:
            </label>

            <validation-provider
              rules="required"
              name="recipientTaxNumber"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="text"
                v-model="recipient.tax_number" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('order.puesc.sent100popup.street') }}:
            </label>

            <validation-provider
              rules="required"
              name="recipientStreet"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="text"
                v-model="recipient.street" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <d-row>
            <d-col cols="6">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.houseNumber') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="recipientHouseNumber"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="recipient.house_number" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>

            <d-col cols="6">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.flatNumber') }}:
                </label>

                <d-input
                  type="text"
                  v-model="recipient.flat_number" />
              </div>
            </d-col>
          </d-row>

          <d-row>
            <d-col cols="6">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.city') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="recipientCity"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="recipient.city" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>

            <d-col cols="3">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.postCode') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="recipientPostCode"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="recipient.post_code" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>

            <d-col cols="3">
              <div class="form-group">
                <label>
                  {{ $t('order.puesc.sent100popup.countryCode') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="recipientCountryCode"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="recipient.country_code" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
          </d-row>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        v-if="!saveInProgress"
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('order.puesc.sent100popup.addRequest') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import AppConfig from './../../.env';
import FormUtils from './../../utils/FormUtils.js';
import datepickerTranslations from './../../data/datepicker-translations.js';
import getPrefferedLanguage from './../../utils/i18nUtils.js';

export default {
  name: 'order-puesc-popup',
  props: [
    'orderID',
    'addressData',
    'countries',
    'customerData',
    'puescData'
  ],
  computed: {
    loadingPuescData () {
      return AppConfig.puescSenderData;
    },
    translationsForDatePicker () {
      return datepickerTranslations[getPrefferedLanguage()];
    }
  },
  data () {
    return {
      weight: 0,
      plannedStartCarriageDate: new Date(),
      loading: {
        street: '',
        house_number: '',
        flat_number: '',
        city: '',
        post_code: ''
      },
      recipient: {
        name: '',
        tax_number: '',
        street: '',
        house_number: '',
        flat_number: '',
        city: '',
        post_code: '',
        country_code: ''
      },
      disabledDates: {
        customPredictor: (date) => {
          let today = new Date()
          today.setHours(0, 0, 0, 0)
          let maxDate = new Date()
          maxDate.setDate(today.getDate() + 9)
          maxDate.setHours(23, 59, 59, 999)
          return date < today || date > maxDate
        }
      },
      // internals
      saveInProgress: false,
    };
  },
  mounted () {
    // retrieve country code
    let receiverCountryCode = '';

    if (this.countries && this.addressData && this.addressData.receiver_address_country_code) {
      receiverCountryCode = this.countries.filter(country => country.id === this.addressData.receiver_address_country_code);

      if (receiverCountryCode[0]) {
        receiverCountryCode = receiverCountryCode[0].address_code;
      } else {
        receiverCountryCode = '';
      }
    }

    // set order weight
    this.weight = this.puescData.weight;
    // set loading data
    this.loading.street = this.loadingPuescData.street;
    this.loading.house_number = this.loadingPuescData.house_number;
    this.loading.flat_number = this.loadingPuescData.flat_number;
    this.loading.city = this.loadingPuescData.city;
    this.loading.post_code = this.loadingPuescData.post_code;
    // set recipient data
    this.recipient.name = this.addressData.receiver_name;
    this.recipient.tax_number = this.customerData.invoice_tax_number;
    this.recipient.street = this.addressData.receiver_address_street;
    this.recipient.house_number = this.addressData.receiver_address_building;
    this.recipient.flat_number = this.addressData.receiver_address_locale;
    this.recipient.city = this.addressData.receiver_address_city;
    this.recipient.post_code = this.addressData.receiver_address_postal_code;
    this.recipient.country_code = receiverCountryCode;
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['sent100-form'], this.submitForm);
    },
    submitForm () {
      this.addSent100Request();
    },
    addSent100Request () {
      this.saveInProgress = true;
      let carriageDate = this.plannedStartCarriageDate ? [this.plannedStartCarriageDate.getFullYear(), this.plannedStartCarriageDate.getMonth() + 1, this.plannedStartCarriageDate.getDate()].map(n => n < 10 ? '0' + n : n).join('-') : null;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/puesc/store-sent-100',
        formData: {
          order_id: this.orderID,
          weight: this.weight,
          planned_start_carriage_date: carriageDate,
          loading: {
            street: this.loading.street,
            house_number: this.loading.house_number,
            flat_number: this.loading.flat_number,
            city: this.loading.city,
            post_code: this.loading.post_code
          },
          recipient: {
            name: this.recipient.name,
            tax_number: this.recipient.tax_number,
            street: this.recipient.street,
            house_number: this.recipient.house_number,
            flat_number: this.recipient.flat_number,
            city: this.recipient.city,
            post_code: this.recipient.post_code,
            country_code: this.recipient.country_code
          }
        },
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('ui.actionFailedTryAgain'),
        successAction: (response) => {
          this.saveInProgress = false;

          if (response.success) {
            Vue.swal({
              title: this.$t('order.puesc.sent100popup.addRequestSuccessTitle'),
              html: this.$t('order.puesc.sent100popup.addRequestSuccessText'),
              type: 'success',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true,
              timer: 2000
            });

            this.$bus.$emit('order-puesc-reload-items');
            this.cancel();
          } else {
            Vue.swal({
              title: this.$t('ui.errorOccured'),
              html: this.$t('ui.tryAgain'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });
          }
        },
        failAction: () => {
          this.saveInProgress = false;
        }
      });
    },
    cancel () {
      this.$bus.$emit('order-puesc-sent100-popup-close');
    }
  }
}
</script>
